import React from "react";
import { Box, Typography } from "@mui/material";
import bgImage from "../../../assets/media/become-provider-bg.jpg";
import operationsIcon from "../../../assets/icons/operations-icon.svg";
import visibilityIcon from "../../../assets/icons/visibility-reach-icon.svg";
import leadGenerationIcon from "../../../assets/icons/lead-gen-icon.svg";
import geoTargetedIcon from "../../../assets/icons/target-access-icon.svg";
import dataInsightsIcon from "../../../assets/icons/analytics-icon.svg";
import trustedPlatformsIcon from "../../../assets/icons/trusted-platforms.svg";
import ongoingSupportIcon from "../../../assets/icons/ongoing-support.svg";
import customizedBusinessCardIcon from "../../../assets/icons/customized-business-card.svg";
const bgGif = "/assets/media/become-provider-bg-vid.mp4";

function Advantages() {
  const advantagesData = [
    // {
    //   title: "Streamlined Operations",
    //   description:
    //     "AFP Horizon may offer scheduling tools, appointment management, and inquiry-handling features to make provider workflows efficient.",
    //   icon: operationsIcon,                     
    // },
    {
      title: "Greater Visibility",
      description: "Be discoverable by families actively searching for funeral and memorial services in your service area.",
      icon: visibilityIcon,
    },
    {
      title: "Lead Generation",
      description:
        "Receive inquiries from families already seeking the services you provide.",
      icon: leadGenerationIcon,
    },
    {
      title: "Trusted Platform",
      description: "Be part of a curated ecosystem designed to connect families with reputable service providers.",
      icon: trustedPlatformsIcon,
    },
    {
      title: "Geo-Targeted Reach",
      description:
        "Connect with families searching within the areas you serve.",
      icon: geoTargetedIcon,
    },
    {
      title: "Reports & Insights",
      description: "View inquiry activity and trends to understand interest in your services.",      
      icon: dataInsightsIcon,
    },
    {
      title: "Ongoing Support",
      description: "Receive onboarding and ongoing support to ensure clarity and consistency.",
      icon: ongoingSupportIcon,
    },
    {
      title: "Customized Business Page",
      description: "Create a dedicated, customized business page to present services clearly — at no additional cost.",
      icon: customizedBusinessCardIcon,
    }
  ];
  return (
    <Box
      sx={{
        position: "relative",
        padding: "2rem",
        gap: "2rem",
        maxHeight: { xs: "none", md: 865, lg: 880 },
        overflow: "hidden",
        fontFamily: "Roboto",
        color: "#FFFFFF",

        "& > *": { position: "relative", zIndex: 1 },

        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background: `
            linear-gradient(rgba(232, 238, 239, 0.9), rgba(232, 238, 239, 0.9)),
            url(${bgImage})
            `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: 0,
        },

        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${bgGif})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.4,
          pointerEvents: "none",
          zIndex: 1,
        },
        mb: 8,
      }}
    >
      <Box sx={{ textAlign: "center", width: "100%" }}>
        <Typography
          variant="h4"
          sx={{
            mb: 8,
            mt: 2,
            fontWeight: "600",
            fontSize: { xs: "24px", md: "32px", lg: "34px" },
            lineHeight: { xs: "28px", md: "36px", lg: "44px" },
            letterSpacing: "-2%",
            textAlign: "center",
            color: "#104145",
          }}
        >
          Advantages of{" "}
          <span style={{ color: "#9F7F2C" }}>Becoming Partner</span>
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
          gap: 6,
          margin: "8px 0",
          mb: 8,
        }}
        className='advantages-becoming-partner-cards-div'
      >
        {advantagesData.map((advantage, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              width: "100%",
              maxWidth: "217px",
              marginBottom: { xs: "2rem", md: 0 },
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              borderBottomRightRadius: "60px",
              padding: "16px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              height: "333px",
              gap: 4,
              "&::before": {
                content: '""',
                position: "absolute",
                left: "-5px",
                bottom: "-5px",
                width: "5px",
                height: "calc(45% + 5px)",
                backgroundColor: "rgba(16, 65, 69, 1)",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                left: "-5px",
                bottom: "-5px",
                width: "calc(50% + 5px)",
                height: "5px",
                backgroundColor: "rgba(16, 65, 69, 1)",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mb: 2,
                mt: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 1,
                  color: "#104145",
                  fontWeight: 600,
                  fontSize: "20px",
                  lineHeight: "24px",
                }}
              >
                {advantage.title}
              </Typography>
              <div
                style={{
                  minWidth: "76px",
                  height: "76px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  backgroundColor: "rgba(235, 210, 141, 1)",
                }}
              >
                <img src={advantage.icon} alt={advantage.title} />
              </div>
            </Box>
            <Typography
              sx={{
                color: "#104145",
                fontSize: "16px",
                lineHeight: "22px",
                fontWeight: 400,
                textAlign: "left",
              }}
            >
              {advantage.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default Advantages;
